import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/category/[id]/category.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/category/[id]/favorites.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/category/[id]/hub.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/banner/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/categories/categories.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/categories/desktop.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/icon/index.tsx");
